module.exports = __webpack_public_path__ + "assets/img/jbm1.cbfa286d.jpg";